import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getFilteredMenuItems } from '../utils/menuUtils';

/**
 * Custom hook to manage menu logic, including navigation handling,
 * active route detection, and filtering menu items based on user role.
 *
 * @param {string} userRole - The role of the current user.
 * @param {Function} onClose - Callback function to close the menu after navigation.
 * @returns {Object} Menu-related functions and filtered menu items.
 */
const useMenuLogic = (userRole, onClose) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = useCallback((path) => location.pathname === path, [location.pathname]);

  const handleNavigation = useCallback(
    (path) => {
      navigate(path);
      onClose();
    },
    [navigate, onClose],
  );

  const filteredMenuItems = getFilteredMenuItems(userRole);

  return { isActive, handleNavigation, filteredMenuItems };
};

export default useMenuLogic;
